import * as React from "react";
import Container from "../../ui-library/container/container";
import { EventCategory } from "../../../utils/analytics";
import Link from "../../ui-library/link/link";
import Image from "../../ui-library/image/image";
import styles from "./footer.styles";
import TwitterLogo from "./twitter.svg";

const Footer: React.FC = () => {
  const twitterLink = (
    <Link
      to="https://twitter.com/CoinomicsPro"
      target="_blank"
      rel="noopener noreferrer"
      analytics={{
        category: EventCategory.Site_Footer,
        action: "Click - Twitter",
        label: "Twitter",
      }}
    >
      <Image src={TwitterLogo} alt="Twitter" />
    </Link>
  );

  return (
    <footer css={styles.root}>
      <Container css={styles.container}>
        <div css={styles.slogan}>
          Always do your own research.
          <br />
          Trade and invest at your own risk.
        </div>

        <div css={styles.linksContainer}>
          <Link
            to="/terms-of-use/"
            css={styles.link}
            analytics={{
              category: EventCategory.Site_Footer,
              action: "Click - Terms of Use",
              label: "Terms of Use",
            }}
          >
            Terms of Use
          </Link>
          <Link
            to="/privacy-policy/"
            css={styles.link}
            analytics={{
              category: EventCategory.Site_Footer,
              action: "Click - Privacy Policy",
              label: "Privacy Policy",
            }}
          >
            Privacy Policy
          </Link>
          <Link
            to="/disclaimer/"
            css={styles.link}
            analytics={{
              category: EventCategory.Site_Footer,
              action: "Click - Disclaimer",
              label: "Disclaimer",
            }}
          >
            Disclaimer
          </Link>
          <div css={styles.twitterDesktop}>{twitterLink}</div>
          <div css={styles.tradeMark}>© 2021 Coinomics</div>
        </div>

        <div css={styles.twitterMobile}>{twitterLink}</div>
        <div css={styles.tradeMarkMobile}>© 2021 Coinomics</div>
      </Container>
    </footer>
  );
};

export default Footer;
